export var BrandColors;
(function (BrandColors) {
    BrandColors["BLACK"] = "#000";
    BrandColors["BLUE"] = "#00B7FF";
    BrandColors["CANVAS"] = "#F4F4F4";
    BrandColors["CHARCOAL"] = "#394649";
    BrandColors["CONCRETE"] = "#DCDEE1";
    BrandColors["NAVY"] = "#002333";
    BrandColors["RED"] = "#FF4A4A";
    BrandColors["VIOLET"] = "#3722D3";
    BrandColors["WANDERGREEN"] = "#00FF84";
    BrandColors["YELLOW"] = "#FFE03D";
    BrandColors["WHITE"] = "#FFF";
})(BrandColors || (BrandColors = {}));
export var SupplementaryColors;
(function (SupplementaryColors) {
    SupplementaryColors["DARKCHARCOAL"] = "#333";
    SupplementaryColors["PHILIPPINESILVER"] = "#B4B8B4";
})(SupplementaryColors || (SupplementaryColors = {}));
//# sourceMappingURL=Colors.js.map